module.exports = __webpack_public_path__ + "dark-material-bg.d914334bfb315da0efe3.jpg";


//////////////////
// WEBPACK FOOTER
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/assets/images/backgrounds/dark-material-bg.jpg
// module id = ../../../../../src/assets/images/backgrounds/dark-material-bg.jpg
// module chunks = main